import React, { createContext, useContext, useState } from 'react';
import { auth } from '../helper/auth';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    // We can add reactive state here if needed, but for now we expose the auth helper
    // and potentially some state that auth.js manages (though auth.js uses localStorage)
    
    // To make it more "React-y", we could sync state with localStorage
    const [user, setUser] = useState(auth.getUser());
    const [isAuthenticated, setIsAuthenticated] = useState(auth.isAuthenticated());

    // We can wrap the auth methods to update state
    const login = (token, userData) => {
        auth.login(token, userData);
        setUser(userData);
        setIsAuthenticated(true);
    };

    const logout = () => {
        auth.logout();
        setUser(null);
        setIsAuthenticated(false);
    };

    const updateUser = (userData) => {
        // Merge with existing user data to preserve fields not in userData
        const updatedUser = { ...user, ...userData };
        auth.login(auth.getToken(), updatedUser); // Update localStorage
        setUser(updatedUser); // Update state
    };

    const value = {
        auth: {
            ...auth,
            login,
            logout
        },
        user,
        updateUser,
        isAuthenticated
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
